(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prigur-feature-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('prigur-feature-slider')) {
    class PrigurFeatureSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-pfs-slide]'));
        if (this.slides.length === 0) return;

        this.mediaSlides = Array.from(this.querySelectorAll('[data-pfs-media]'));
        this.labels = Array.from(this.querySelectorAll('[data-pfs-label]'));
        this.dots = Array.from(this.querySelectorAll('[data-pfs-dot]'));
        this.counter = this.querySelector('[data-pfs-current]');
        this.status = this.querySelector('[data-pfs-status]');
        this.toggle = this.querySelector('[data-pfs-toggle]');
        this.stage = this.querySelector('.pfs__stage');
        this.index = 0;
        this.pauseReasons = new Set();

        this.onClick = this.onClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onAnimationEnd = this.onAnimationEnd.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.onBlockDeselect = this.onBlockDeselect.bind(this);

        this.addEventListener('click', this.onClick);
        this.stage.addEventListener('keydown', this.onKeydown);
        this.addEventListener('animationend', this.onAnimationEnd);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        this.setupSwipe();
        this.setupVariants();
        this.setupCountdowns();
        this.setupAutoplay();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('animationend', this.onAnimationEnd);
        this.stage?.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
        this.viewportObserver?.disconnect();
        clearInterval(this.countdownTimer);
      }

      get count() {
        return this.slides.length;
      }

      goTo(index, { announce = true } = {}) {
        const next = (index + this.count) % this.count;
        if (next === this.index) return;
        this.index = next;

        const groups = [this.slides, this.mediaSlides, this.labels];
        groups.forEach((items) => {
          items.forEach((el, i) => el.classList.toggle('is-active', i === next));
        });

        [...this.slides, ...this.mediaSlides].forEach((el) => {
          const active = el.classList.contains('is-active');
          el.toggleAttribute('inert', !active);
          if (active) el.removeAttribute('aria-hidden');
          else el.setAttribute('aria-hidden', 'true');
        });

        this.dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === next);
          if (i === next) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });

        if (this.counter) this.counter.textContent = String(next + 1).padStart(2, '0');

        if (announce && this.status) {
          const label = this.labels[next]?.textContent.trim() || '';
          this.status.textContent = '';
          requestAnimationFrame(() => {
            this.status.textContent = `Produkt ${next + 1} von ${this.count}: ${label}`;
          });
        }
      }

      next(options) {
        this.goTo(this.index + 1, options);
      }

      prev(options) {
        this.goTo(this.index - 1, options);
      }

      onClick(event) {
        const target = event.target.closest('button');
        if (!target || !this.contains(target)) return;

        if (target.hasAttribute('data-pfs-next')) this.next();
        else if (target.hasAttribute('data-pfs-prev')) this.prev();
        else if (target.hasAttribute('data-pfs-dot')) this.goTo(this.dots.indexOf(target));
        else if (target.hasAttribute('data-pfs-thumb')) this.showImage(target);
        else if (target.hasAttribute('data-pfs-toggle')) this.toggleAutoplay();
      }

      onKeydown(event) {
        if (event.target.closest('input, textarea, select')) return;
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.next();
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.prev();
        }
      }

      showImage(thumb) {
        const group = thumb.closest('[data-pfs-media]');
        this.setActiveImage(group, Number(thumb.dataset.pfsThumb));
      }

      setActiveImage(group, index) {
        group.querySelectorAll('[data-pfs-image]').forEach((img, i) => {
          img.classList.toggle('is-active', i === index);
        });
        group.querySelectorAll('[data-pfs-thumb]').forEach((btn) => {
          btn.setAttribute('aria-pressed', String(Number(btn.dataset.pfsThumb) === index));
        });
      }

      setupVariants() {
        this.querySelectorAll('[data-pfs-variants]').forEach((picker) => {
          let data;
          try {
            data = JSON.parse(picker.querySelector('[data-pfs-variant-json]').textContent);
          } catch (error) {
            return;
          }

          const slide = picker.closest('[data-pfs-slide]');
          const state = {
            data,
            selected: [...data.selected],
            slide,
            media: this.mediaSlides[this.slides.indexOf(slide)],
          };
          picker.addEventListener('change', (event) => this.onVariantChange(event, picker, state));
        });
      }

      onVariantChange(event, picker, state) {
        const fieldset = event.target.closest('[data-option-index]');
        if (!fieldset) return;
        const optionIndex = Number(fieldset.dataset.optionIndex);
        state.selected[optionIndex] = event.target.value;

        const { variants } = state.data;
        const matches = (v) => v.options.every((value, i) => value === state.selected[i]);
        let variant = variants.find(matches);

        // Combination doesn't exist: keep the clicked value, take the closest real variant
        if (!variant) {
          const withValue = variants.filter((v) => v.options[optionIndex] === event.target.value);
          variant = withValue.find((v) => v.available) || withValue[0];
          if (!variant) return;
          state.selected = [...variant.options];
        }

        picker.querySelectorAll('[data-option-index]').forEach((set) => {
          const i = Number(set.dataset.optionIndex);
          set.querySelectorAll('input').forEach((input) => {
            input.checked = input.value === state.selected[i];
            const available = variants.some(
              (v) =>
                v.available &&
                v.options[i] === input.value &&
                v.options.every((value, j) => j === i || value === state.selected[j])
            );
            input.closest('.pfs__value').classList.toggle('is-unavailable', !available);
          });
          const label = set.querySelector('[data-pfs-option-value]');
          if (label) label.textContent = state.selected[i];
        });

        const price = state.slide.querySelector('[data-pfs-price]');
        if (price) price.textContent = variant.price;
        const compare = state.slide.querySelector('[data-pfs-compare]');
        if (compare) {
          compare.hidden = !variant.compare;
          compare.querySelector('[data-pfs-compare-value]').textContent = variant.compare;
        }
        const cta = state.slide.querySelector('[data-pfs-cta]');
        if (cta) cta.href = variant.url;

        if (state.media && variant.src) this.showVariantImage(state.media, variant);
      }

      showVariantImage(group, variant) {
        const images = Array.from(group.querySelectorAll('[data-pfs-image]'));
        const existing = images.findIndex((el) => el.dataset.imageId === String(variant.imageId));
        if (existing > -1) {
          this.setActiveImage(group, existing);
          return;
        }

        // Variant image isn't among the slide's images: show it in an extra layer without a thumbnail
        let layer = group.querySelector('[data-pfs-variant-layer]');
        if (!layer) {
          layer = document.createElement('div');
          layer.className = 'pfs__image';
          layer.setAttribute('data-pfs-image', '');
          layer.setAttribute('data-pfs-variant-layer', '');
          layer.appendChild(document.createElement('img'));
          group.querySelector('.pfs__main').appendChild(layer);
        }
        const img = layer.querySelector('img');
        if (variant.srcset) img.srcset = variant.srcset;
        img.sizes = '(min-width: 990px) 52vw, 100vw';
        img.src = variant.src;
        img.alt = variant.alt || '';
        layer.dataset.imageId = String(variant.imageId);
        this.setActiveImage(group, Array.from(group.querySelectorAll('[data-pfs-image]')).indexOf(layer));
      }

      setupSwipe() {
        if (this.count < 2) return;
        let startX = 0;
        let startY = 0;
        let tracking = false;

        this.mediaSlides.forEach((slide) => {
          const main = slide.querySelector('.pfs__main');
          if (!main) return;

          main.addEventListener('pointerdown', (event) => {
            startX = event.clientX;
            startY = event.clientY;
            tracking = event.pointerType !== 'mouse';
          });

          main.addEventListener('pointerup', (event) => {
            if (!tracking) return;
            tracking = false;
            const dx = event.clientX - startX;
            const dy = event.clientY - startY;
            if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
              if (dx < 0) this.next();
              else this.prev();
            }
          });

          main.addEventListener('pointercancel', () => {
            tracking = false;
          });

          // Swipe should change slide, not follow the link
          main.addEventListener('click', (event) => {
            if (Math.abs(event.clientX - startX) > 10) event.preventDefault();
          });
        });
      }

      setupCountdowns() {
        this.countdowns = Array.from(this.querySelectorAll('[data-pfs-countdown]'))
          .map((el) => ({ el, end: Date.parse(el.dataset.end) }))
          .filter(({ end }) => !Number.isNaN(end));

        if (this.countdowns.length === 0) return;

        this.countdowns.forEach(({ el }) => {
          el.querySelector('.pfs__timer')?.removeAttribute('hidden');
        });

        const pad = (n) => String(n).padStart(2, '0');
        const tick = () => {
          const now = Date.now();
          this.countdowns.forEach((item) => {
            if (item.ended) return;
            const diff = item.end - now;
            if (diff <= 0) {
              item.ended = true;
              item.el.classList.add('is-ended');
              item.el.querySelector('.pfs__timer')?.setAttribute('hidden', '');
              const label = item.el.querySelector('[data-pfs-countdown-label]');
              if (label && item.el.dataset.endedText) label.textContent = item.el.dataset.endedText;
              return;
            }
            const s = Math.floor(diff / 1000);
            const values = {
              d: Math.floor(s / 86400),
              h: Math.floor((s % 86400) / 3600),
              m: Math.floor((s % 3600) / 60),
              s: s % 60,
            };
            Object.entries(values).forEach(([unit, value]) => {
              const node = item.el.querySelector(`[data-unit="${unit}"]`);
              if (node) node.textContent = pad(value);
            });
          });
        };

        tick();
        this.countdownTimer = setInterval(tick, 1000);
      }

      setupAutoplay() {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const designMode = window.Shopify && window.Shopify.designMode;
        if (this.dataset.autoplay !== 'true' || this.count < 2 || reduced || designMode) {
          this.toggle?.setAttribute('hidden', '');
          return;
        }

        this.toggleAttribute('data-playing', true);

        const pauseOn = (el, start, end, reason) => {
          el.addEventListener(start, () => this.setPaused(reason, true));
          el.addEventListener(end, (event) => {
            if (end === 'focusout' && this.stage.contains(event.relatedTarget)) return;
            this.setPaused(reason, false);
          });
        };
        pauseOn(this.stage, 'pointerenter', 'pointerleave', 'hover');
        pauseOn(this.stage, 'focusin', 'focusout', 'focus');

        this.viewportObserver = new IntersectionObserver(
          ([entry]) => this.setPaused('offscreen', !entry.isIntersecting),
          { threshold: 0.25 }
        );
        this.viewportObserver.observe(this);
      }

      setPaused(reason, paused) {
        if (paused) this.pauseReasons.add(reason);
        else this.pauseReasons.delete(reason);
        this.toggleAttribute('data-paused', this.pauseReasons.size > 0);
      }

      toggleAutoplay() {
        const stopped = this.toggle.getAttribute('aria-pressed') !== 'true';
        this.toggle.setAttribute('aria-pressed', String(stopped));
        this.toggle.setAttribute(
          'aria-label',
          stopped ? 'Automatischen Wechsel starten' : 'Automatischen Wechsel pausieren'
        );
        this.setPaused('user', stopped);
      }

      onAnimationEnd(event) {
        if (event.animationName !== 'pfs-progress') return;
        this.next({ announce: false });
      }

      onBlockSelect(event) {
        const slide = event.target.closest?.('[data-pfs-slide]');
        if (!slide || !this.contains(slide)) return;
        this.setPaused('editor', true);
        this.goTo(this.slides.indexOf(slide), { announce: false });
      }

      onBlockDeselect(event) {
        if (this.contains(event.target)) this.setPaused('editor', false);
      }
    }

    customElements.define('prigur-feature-slider', PrigurFeatureSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
